import type { IIssueRepository } from '../repositories/IIssueRepository.js';
import type { IssueEntity } from '../entities/IssueEntity.js';

interface Deps { issueRepository: IIssueRepository; }

export function createGetIssueByIdUseCase({ issueRepository }: Deps) {
  return async function getIssueById(id: string): Promise<IssueEntity | null> {
    return issueRepository.getById(id);
  };
}
